import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', () => {
  const toasts = ref([]);
  const navigationOpen = ref(false);

  function toast(message, kind = 'info', timeout = 4200) {
    const id = crypto.randomUUID();
    const details = message && typeof message === 'object' ? message : { message };
    const item = { id, kind: details.kind || kind, ...details };
    toasts.value.push(item);
    window.setTimeout(() => dismiss(id), timeout);
    return id;
  }

  function notification({ title = 'Новое уведомление', message, type = 'platform', url = null }, timeout = 7000) {
    return toast({ title, message, notificationType: type, url, kind: 'notification' }, 'notification', timeout);
  }

  function dismiss(id) {
    toasts.value = toasts.value.filter((item) => item.id !== id);
  }

  return { toasts, navigationOpen, toast, notification, dismiss };
});
